import { ChangeDetectionStrategy, Component, ContentChild, input, InputSignal, TemplateRef } from '@angular/core'
import { RowInterface } from '@shared/components/common/table/core/interfaces/row.interface'

@Component({
	selector: 'app-table-dynamic-row',
	templateUrl: 'table-dynamic-row.component.html',
	styleUrl: 'table-dynamic-row.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableDynamicRowComponent {
	public rowSettings: InputSignal<RowInterface<null> | null> = input<RowInterface<null> | null>(null)

	@ContentChild(TemplateRef) template: TemplateRef<unknown> | null = null
}
